module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "twitter.25c9a221.svg";